import { onFlightActivity } from "common/signalR";
import ActivityPanel from "components/ActivityPanel/ActivityPanel";
import React from "react";
import { FlightActivityCard } from "./FlightActivityCard";
import { useCurrentUser } from "common/SessionContext";

interface Props {
  flightId: number
  config: server.dto.ActivityPanelConfig
}

export const FlightActivityPanel = (props: Props) => {
  const currentUser = useCurrentUser();
  return <ActivityPanel<server.dto.FlightActivity>
    config={props.config}
    fetchActivities={(page, perPage) => window.CoreApi.Flight.ListActivity({ itemId: props.flightId, page, perPage })}
    renderActivity={(activity => <FlightActivityCard
      key={activity.activityId}
      activity={activity}
    />)}
    onActivityRegisterFn={onFlightActivity}
    onActivity={(activity) => {
      if (activity.itemId !== props.flightId) return { refreshActivities: false };

      const iAmActor = (activity.actor?.userId === currentUser.userId);

      return { refreshActivities: iAmActor };
    }}
  />
}